export default __webpack_public_path__ + "static/TheBahamasqueenofJunkanoo-fb640ba89db3417851931ae36d2c5f41.jpg";